module.exports = __webpack_public_path__ + "static/media/carousel-cgc-website-05.eabde3ab.png";